<template>
  <div class="menu-wrapper">
    <!-- Loader -->
    <div v-if="loading" class="loader">
      <div class="loader-content">
        <h1 class="load-text">Angtara</h1>
        <div class="progress-wrapper">
          <div class="progress-bar" :style="{ width: progress + '%' }"></div>
        </div>
      </div>
    </div>

    <!-- Book -->
    <div v-show="!loading" class="menu-container">
      <div ref="book"></div>
    </div>

    <!-- Controls -->
    <div class="controls">
      <button @click="prevPage">Prev</button>
      <span>
        PAGE {{ currentPage }} / {{ totalPages }}
      </span>
      <button @click="nextPage">Next</button>
    </div>
  </div>
</template>

<script>
import { PageFlip } from "page-flip";

export default {
  data() {
    return {
      PDF_URL:
        "https://cdn.shopify.com/s/files/1/0667/5772/2211/files/Angtara_Menu.pdf",
      loading: true,
      progress: 0,
      totalPages: 0,
      currentPage: 1,
      pageFlip: null,
    };
  },

  async mounted() {
    await this.initMenu();
  },

  methods: {
    async initMenu() {
      const pdfjsLib = window['pdfjs-dist/build/pdf'];

      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";
      try {
        const loadingTask = pdfjsLib.getDocument(this.PDF_URL);
        const pdf = await loadingTask.promise;

        this.totalPages = pdf.numPages;

        const bookDiv = this.$refs.book;

        for (let i = 1; i <= this.totalPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 2 });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // FIX: white background
          context.fillStyle = "white";
          context.fillRect(0, 0, canvas.width, canvas.height);

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;

          bookDiv.appendChild(canvas);

          this.progress = Math.round((i / this.totalPages) * 100);
        }

        this.loading = false;

        // Init PageFlip
        this.pageFlip = new PageFlip(bookDiv, {
          width: 550,
          height: 800,
          size: "stretch",
          minWidth: 315,
          maxWidth: 1000,
          minHeight: 420,
          maxHeight: 1350,
          showCover: false,
          useMouseEvents: true,
          drawShadow: true,
          maxShadowOpacity: 0.2,
          usePortrait: true,
          startPage: 1,
          autoSize: true,
          flippingTime: 500,
          swipeDistance: 30,
          clickEventForward: false,
          useHardCover: true
        });

        this.pageFlip.loadFromHTML(bookDiv.querySelectorAll("canvas"));

        this.pageFlip.on("flip", (e) => {
          this.currentPage = e.data + 1;
        });
      } catch (err) {
        console.error(err);
      }
    },

    nextPage() {
      if (this.pageFlip) this.pageFlip.flipNext();
    },

    prevPage() {
      if (this.pageFlip) this.pageFlip.flipPrev();
    },
  },
};
</script>

<style scoped>

.menu-wrapper {
  --accent: #647E3D;
  --text-main: #1a1a1a;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  background: #ffffff;
  color: var(--text-main);
}

/* Loader */
.loader {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: white;
  z-index: 9999;
}

.loader-content {
  text-align: center;
}

.load-text {
  font-family: 'Anton', sans-serif;
  font-size: 3rem;
  color: var(--accent);
  margin-bottom: 16px;
  letter-spacing: 1px;
}

.progress-wrapper {
  width: 200px;
  height: 4px;
  background: #eee;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: var(--accent);
  transition: width 0.3s ease;
}

/* Book container */
.menu-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

/* Controls */
.controls {
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  
  z-index:1;
}

.controls span {
  font-size: 13px;
  font-weight: 500;
  color: #888;
}

/* Buttons */
button {
  font-family: 'Anton', sans-serif;
  letter-spacing: 1px;
  padding: 10px 20px;
  border-radius: 8px;
  border: 2px solid var(--accent);
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 90px;
}

/* Prev */
button:first-of-type {
  background: transparent;
  color: var(--accent);
}

/* Next */
button:last-of-type {
  background: var(--accent);
  color: white;
}

/* Hover */
button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
}

/* Active */
button:active {
  transform: scale(0.96);
}

/* Mobile */
@media (max-width: 768px) {
  .load-text {
    font-size: 2.2rem;
  }

  .controls {
    gap: 10px;
  }

  button {
    padding: 8px 14px;
    font-size: 12px;
  }
}

/* Fix transparency during flip */
canvas {
  background: #ffffff !important;
}

.stf__page {
  background: #ffffff !important;
}

.stf__parent {
  max-height: calc(100dvh - 130px) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/teaser/Homepage.vue